import React from 'react';
import { useSelector } from 'react-redux';
import Alert, { KIND, VARIANT } from '@nykaa/ui-components/Alert';
import { State } from 'store/types';
import { MessageWrapper } from 'layouts/ShoppingBag/styled';

const Message = () => {
  const config = useSelector(
    (state: State) =>
      state.remoteConfig.configs?.cartGenericMessages?.notificationBanner
  ) || { status: false, message: '' };

  if (!config.status) {
    return <></>;
  }

  return (
    <MessageWrapper data-test-id="cart_info_message">
      <Alert
        variant={VARIANT.inline}
        withIcon={true}
        kind={KIND.info}
        message={config.message}
        data-test-id="desc-alert"
      />
    </MessageWrapper>
  );
};

export default Message;
